import { observer } from "mobx-react-lite";
import infoStyles from '../Info.module.css';
import styles from './AddressInfo.module.css';

function AddressInfo({ address, className, onClick }: IAddressInfoProps) {
    return (
        <div className={[infoStyles.container, styles.container, className].join(" ")} onClick={onClick}>
            {address}
        </div>
    );
}

export interface IAddressInfoProps {
    address: string;
    className?: string;
    onClick?: () => void;
}

export default observer(AddressInfo);